<h2 mat-dialog-title>{{ "PRIVACY_POLICE.TITLE" | translate }}</h2>
<mat-dialog-content class="mat-typography">
    <p [innerHTML]="privacyPolicy | safeHTML"></p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button [id]="'button_ClosePrivacy'" mat-button mat-dialog-close>
        {{ "PRIVACY_POLICE.BUTTON_LABEL" | translate }}
    </button>
</mat-dialog-actions>
